module.exports = __webpack_public_path__ + "img/tickets-plane.fd8040d3.svg";